import { Outlet } from 'react-router-dom';

export default function LessonsLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
